import { Label, Typography } from '@coolblue-development/becky';
import { useCopyToClipboard } from '../../../../../hooks/useCopyToClipboard';
import CopyIcon from '../../../Icons/CopyIcon';

interface CopyContactIdButtonProps {
  contactId: string;
}

export const CopyContactIdButton = ({ contactId }: CopyContactIdButtonProps): JSX.Element => {
  const { copied, copy } = useCopyToClipboard();

  return (
    <Label
      data-testid="email-contact-id"
      variant="subtle"
      onClick={e => {
        e.stopPropagation();
        copy(contactId);
      }}
      sx={{
        gap: '10px',
        '&& > *': { marginBottom: '0px' },
        cursor: 'pointer',
        opacity: copied ? 0.6 : 1,
        transition: 'opacity 0.2s',
        '&:hover': { opacity: 0.75 }
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        {copied ? 'Copied!' : 'ContactID'}
      </Typography>

      <CopyIcon color="#666" />
    </Label>
  );
};

export default CopyContactIdButton;
